export const getVisibleCTAList = (ctaList) =>
  (Array.isArray(ctaList) ? ctaList : []).filter((cta) => !cta?.hideCTA);

export const isAlternatingImageRight = (index, startRight = false) =>
  startRight ? index % 2 === 0 : index % 2 === 1;

export const CTA_BUTTON_DESTINATIONS = {
  custom: "Custom URL",
  register: "Register",
  faq: "FAQ",
  gallery: "Gallery",
  terms: "Terms",
};

const getEventBasePath = (eventData, passcode) => {
  if (!eventData?.publicUrl) {
    return "";
  }

  return `/${eventData.publicUrl}${passcode ? `/${passcode}` : ""}`;
};

const isEventPageEnabled = (eventData, destination) => {
  const enabledFields = {
    register: "allowReg",
    faq: "allowFAQ",
    gallery: "allowGallery",
    terms: "allowTerms",
  };

  return Boolean(eventData?.[enabledFields[destination]]);
};

export const getCTAButtonDestinationOptions = (eventData) =>
  Object.entries(CTA_BUTTON_DESTINATIONS)
    .filter(
      ([destination]) =>
        destination === "custom" ||
        isEventPageEnabled(eventData, destination),
    )
    .map(([value, label]) => ({ label, value }));

export const getEventPageLink = (eventData, destination, passcode) => {
  const basePath = getEventBasePath(eventData, passcode);

  if (!basePath || !isEventPageEnabled(eventData, destination)) {
    return "";
  }

  if (destination === "register") {
    return `/register${basePath}`;
  }

  const inlinePageFlags = {
    faq: {
      landing: "showFAQInlineLanding",
      register: "showFAQInline",
    },
    terms: {
      landing: "showTermsInlineLanding",
      register: "showTermsInline",
    },
  }[destination];

  if (inlinePageFlags) {
    if (eventData?.[inlinePageFlags.landing]) {
      return `${basePath}#${destination}`;
    }
    if (eventData?.[inlinePageFlags.register]) {
      return `/register${basePath}#${destination}`;
    }
  }

  return `${basePath}/${destination}`;
};

const getCTAButtonField = (button, field) =>
  `${field}${button === 2 ? "2" : ""}`;

export const getCTAButtonDestination = (cta, button = 1) =>
  cta?.[getCTAButtonField(button, "ctaLinkType")] || "custom";

export const getCTAButtonLink = (
  cta,
  eventData,
  button = 1,
  passcode,
) => {
  const destination = getCTAButtonDestination(cta, button);
  const customLink =
    cta?.[getCTAButtonField(button, "ctaLink")] || cta?.publicUrl || "";

  if (destination === "custom") {
    return customLink;
  }

  return getEventPageLink(eventData, destination, passcode) || customLink;
};

export const getCTAButtonTarget = (cta, button = 1, eventData) => {
  const destination = getCTAButtonDestination(cta, button);
  const usesCustomLink =
    destination === "custom" ||
    (eventData && !isEventPageEnabled(eventData, destination));

  return usesCustomLink && cta?.[getCTAButtonField(button, "ctaExternal")]
    ? "_blank"
    : "";
};
